// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Buttons_buttons__215mK","left":"Buttons_left__4oEg7"};